<script>
  import AtAGlance from './AtAGlance.svelte';
  import AtAGlancePrecinctsReporting from './AtAGlancePrecinctsReporting.svelte';
  /**
   *  @type {object}
   */
  export let feed;

  /**
   * @type {Map<string, import('../types.d').Crosswalk>}
   */
  export let crosswalk;


  // $: trueOrFalse = []

  $: races = feed;

  function doAllRacesHaveVotes(races){
    let trueOrFalse = []
    races
    .map((r) => {
      r['store'].subscribe((value) => {
        return trueOrFalse.push(value.total_votes > 0);
      });
    })
    return trueOrFalse.every((el) => el === true);
  }

  $: votesInTest = doAllRacesHaveVotes(races);

</script>



<div class="aag-container" aria-hidden='false'>
  <div class="aag-races-container display-grid grid-cols-2 grid-gap-3 mb-3 mt-1">
    {#each races as race}
      {#if race.race != 'precincts'}
        <div class="race-container" id="aag-{race.id}">
          <AtAGlance 
          race={race.store} 
          label={race.label} 
          {crosswalk}
          />
        </div>
      {/if}
    {/each}
  </div>
</div>